<div class="container" *transloco="let t; read: 'authModule.login-page'">
  <div class="loading">
    <mat-spinner class="spinner"></mat-spinner>
    <div>{{t('initialize-openid')}}</div>
  </div>
</div>
